import { translate } from 'src/app/project/features/translate/translate';
import { TCustomField } from '../../custom-fields.model';

export function checkBulkFieldTooltip(customField: TCustomField): string {
  if (customField.subValuesActive && !customField.lockedValue) {
    return translate('prompt_bulk_changes_subfields_edit_disabled');
  }

  return '';
}
